import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import {
  Modal, ModalBody, Button, Form, FormGroup, Label, Input,
} from 'reactstrap';
import { staticConstants, getTimeAgoFormat, capitalizeEveryWord } from '../../utils';

function RequestReject(props) {
  const {
    isOpen, onClose, popUpData, updateRequestStatus,
  } = props;
  const { popUpData: { createdAt, userId: { artistImage, name } } } = props;

  const [modal, setModal] = useState(isOpen);
  const [otherReasonValue, setOtherReasonValue] = useState('');
  const [rejectReasonIdx, setRejectReasonIdx] = useState(-1);
  const [rejectReason, setRejectReason] = useState('');
  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const hideModal = () => {
    toggle();
    onClose();
  };


  const toggleRejectReason = (defaultReason, selectedIndex) => {
    setRejectReason(rejectReasonIdx === selectedIndex ? '' : defaultReason);
    setRejectReasonIdx(rejectReasonIdx === selectedIndex ? -1 : selectedIndex);
  };

  const renderRejectReason = () => {
    const reasonList = staticConstants.OFFER_REJECT_REASON;
    return map(reasonList, (item, index) => item && (
      <div className="react-col-section" key={`reason-${item.value}`} onClick={() => { toggleRejectReason(item.label, index); }}>
        <label className="reason-col" htmlFor={`reason${index + 1}`}>
          <input
            key={index}
            type="checkbox"
            checked={item.value === (rejectReasonIdx + 1)}
          />
          <span>{item.label}</span>
        </label>
      </div>
    ));
  };

  return (
    <Modal isOpen={modal} className="modal-request modal-beta-request modal-beta-request-small modal-dialog-centered">
      <ModalBody>
        <Form className="modal-request-content">
          <span
            className="icon icon-cross"
            onClick={hideModal}
          />
          <h4>Select a Reason</h4>
          <div className="request-user">
            <span>
              <img
                src={artistImage}
                alt="artist"
                className="image-cover"
              />
            </span>
            <div className="request-user-detail">
              <h3>{capitalizeEveryWord(name)}</h3>
              <p>
                Applied
                {' '}
                {getTimeAgoFormat(createdAt)}
              </p>
            </div>
          </div>
          <div className="reason-col-wrap">
            <label className="reason-col mw-100 head">
              <span>“Thank you so much for applying. Unfortunately you don&apos;t fill one or more campaign parameters.”</span>
            </label>
            {renderRejectReason()}
          </div>
          <FormGroup>
            <Label
              for="Bio"
            >
              Other reason for rejection
            </Label>
            <Input
              type="textarea"
              className="small"
              name="otherReason"
              value={otherReasonValue}
              onChange={(e) => setOtherReasonValue(e.target.value)}
            />
          </FormGroup>
          <div className="modal-request-small-btn-group">
            <Button
              color="reject"
              disabled={!otherReasonValue && !rejectReason}
              onClick={() => {
                updateRequestStatus(
                  staticConstants.STATUS_TYPE.REJECTED, popUpData,
                  { preDefined: rejectReason, custom: otherReasonValue },
                );
              }}
            >
              Reject & notify
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}

RequestReject.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  updateRequestStatus: PropTypes.func.isRequired,
  popUpData: PropTypes.shape({
    createdAt: PropTypes.string,
    userId: PropTypes.shape({
      artistImage: PropTypes.string,
      _id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default RequestReject;
